/* @jsx h */
import { computed, defineComponent, h } from "vue";
import { localDate, shiftDate, weekdayNames } from "../WorkDay/shared/dates";

type Props = {
  /** First day of the month, YYYY-MM-01. */
  month: string;
  selected: string[];
  /** Weekdays (1–7) already chosen; their dates are tinted. */
  weekdays?: number[];
  onToggle?: (date: string) => void;
};

// A Monday-first month to tick dates on.
export const MonthCalendar = defineComponent<Props>({
  name: "MonthCalendar",
  props: ["month", "selected", "weekdays", "onToggle"],
  setup(props) {
    const names = weekdayNames("short");
    const cells = computed(() => {
      const first = new Date(`${props.month}T12:00:00`);
      const lead = (first.getDay() + 6) % 7;
      const days = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
      return [...Array(lead).fill(null), ...Array.from({ length: days }, (_, i) => shiftDate(props.month, i))];
    });
    return () => {
      const today = localDate();
      return (
        <div>
          <div class="mb-1 grid grid-cols-7 text-center text-[11px] font-medium uppercase text-base-content/50">
            {names.map((n) => (
              <div key={n}>{n}</div>
            ))}
          </div>
          <div class="grid grid-cols-7 gap-1">
            {cells.value.map((d, i) => {
              if (!d) return <div key={`x${i}`} />;
              const on = props.selected.includes(d);
              const dow = ((new Date(`${d}T12:00:00`).getDay() + 6) % 7) + 1;
              const tinted = !on && props.weekdays?.includes(dow);
              return (
                <button
                  key={d}
                  type="button"
                  disabled={!props.onToggle || d < today}
                  class={[
                    "aspect-square rounded-lg text-sm tabular-nums transition",
                    on ? "bg-primary font-semibold text-primary-content" : tinted ? "bg-primary/15" : "hover:bg-base-200",
                    d < today ? "opacity-30" : "",
                  ].join(" ")}
                  onClick={() => props.onToggle?.(d)}
                >
                  {Number(d.slice(8))}
                </button>
              );
            })}
          </div>
        </div>
      );
    };
  },
});
